import script from "./Scroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./Scroll.vue?vue&type=script&setup=true&lang=ts"

import "./Scroll.vue?vue&type=style&index=0&id=0e4b7279&lang=scss"

const __exports__ = script;

export default __exports__